/**
 * Retry muted autoplay after the first user gesture.
 *
 * iOS Low Power Mode (and some data-saver browsers) reject autoplay even when
 * the video is muted and inline. play() is allowed after a tap, click, or key.
 * There is no way to start playback before that while Low Power Mode is on.
 */
(() => {
  const hideControls = (video) => {
    video.controls = false;
    video.removeAttribute("controls");
    video.disablePictureInPicture = true;
    if ("disableRemotePlayback" in video) video.disableRemotePlayback = true;
  };

  const play = (video) => {
    hideControls(video);
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    const attempt = video.play();
    if (attempt) {
      attempt.catch(() => {
        hideControls(video);
      });
    }
  };

  const playAll = () => {
    document.querySelectorAll("video[autoplay]").forEach(play);
  };

  const events = ["pointerdown", "touchstart", "keydown"];
  const unlock = () => {
    playAll();
    events.forEach((event) => {
      window.removeEventListener(event, unlock, { capture: true });
    });
  };

  playAll();
  events.forEach((event) => {
    window.addEventListener(event, unlock, { capture: true, passive: true });
  });
})();
